import {push} from "connected-react-router";
import { ADV_ID_ROUTE} from "../components/Root/routes";

const startOver= () => async (dispatch) =>
{
    dispatch(push(ADV_ID_ROUTE));
};
export default startOver;